module.exports = __webpack_public_path__ + "img/9a7920dbb7e7df329597a60a0597ee5d.svg";